import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import MultinodePicker from "Components/CommonComponents/MultinodePicker";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import { Checkbox, Input, Switch, Spin } from "antd";
import { useEffect, useState, useMemo, useCallback } from "react";
import { Card } from "reactstrap";
import styled from "styled-components";
import { getAllNodes } from "utilFunctions/helperFunctions/utilFunctions";
import "../index.css";
import { SearchOutlined } from "@ant-design/icons";
const ScheduledDiv2Card = styled<any>(Card)`
  height: ${({ screen, mode }: any) =>
    ["mybatchTestSyllabus"].includes(mode)
      ? ["xs", "sm", "md"].includes(screen)
        ? "calc(100vh - 66px)"
        : "100%"
      : "100%"};

  overflow: auto;
  border: ${({ screen, mode }: any) =>
    ["lectureDetailTab", "mybatchTestSyllabus"].includes(mode)
      ? "0px"
      : ["xs", "sm", "md"].includes(screen)
      ? "0px"
      : "1px solid #AFAFAF !important"};
`;
const TreeDiv = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "12px 16px"};
`;

const PlannedLectureViewCard = ({
  expandTopic,
  checkedTopicCovered,
  allCoveredTopics,
  allCourseNodes,
  handleCheckedNodes,
  handleOnlyCheckedNodes,
  handleRemoveUnCheckKey,
  handleOnlyAllCheckedNodes,
  screen,
  mode,
  isMarkedAsRevision,
  isRevisionChapterSelected,
  header,
  chapterNodeDetail,
  lecturePrecheckedNodes,
  courseNodePL,
  isPlannedMode,
  checkeds,
  setCheckeds,
  onChange,
  prevCheckedTopicCovered,
  selectedPlannedLecture,
}: any) => {
  const handleCheckedNodesCard = (data: any) => {
    handleCheckedNodes(data);
  };
  const handleOnlyCheckedNodesCard = (data: any) => {
    handleOnlyCheckedNodes(data);
  };
  const handleRemoveUnCheckKeyCard = (data: any) => {
    handleRemoveUnCheckKey(data);
  };
  const handleOnlyAllCheckedNodesCard = (data: any) => {
    handleOnlyAllCheckedNodes(data);
  };

  const [isPLModeEnabled, setIsPLModeEnabled] = useState(
    mode === "myScheduleHome" ? true : false
  );
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    if (searchValue !== debouncedSearch) {
      setIsSearching(true);
    }
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
      setIsSearching(false);
    }, 3000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const filterNodes = useCallback(
    (nodes: any[]): any[] => {
      return nodes
        .map((node: any) => {
          const isPresentPL =
            !isPLModeEnabled ||
            !courseNodePL ||
            !!courseNodePL[String(node.key)];
          const isPresentSearch =
            !debouncedSearch ||
            node.title?.toLowerCase().includes(debouncedSearch.toLowerCase());

          const children =
            node.children && node.children.length > 0
              ? filterNodes(node.children)
              : [];

          if ((isPresentPL && isPresentSearch) || children.length > 0) {
            return { ...node, children };
          }
          return null;
        })
        .filter((node: any) => node !== null);
    },
    [isPLModeEnabled, courseNodePL, debouncedSearch]
  );

  const filteredCourseNodes = useMemo(
    () => filterNodes(allCourseNodes || []),
    [allCourseNodes, filterNodes]
  );

  useEffect(() => {
    if (
      filteredCourseNodes &&
      filteredCourseNodes.length &&
      mode != "mybatchTestSyllabus"
    ) {
      const allNodes = getAllNodes(filteredCourseNodes)
        .filter((ele: any) => !ele.children || ele.children.length === 0)
        .map((ele: any) => String(ele.key));

      const isEveryExits =
        allNodes.length > 0 &&
        allNodes.every((ele: any) => checkedTopicCovered.includes(ele));

      setCheckeds && setCheckeds(isEveryExits);
    } else {
      setCheckeds && setCheckeds(false);
    }
  }, [filteredCourseNodes, checkedTopicCovered, courseNodePL]);
  const label = `${!checkeds ? "Select all" : "Deselect all"}`;
  const isDisable = useMemo(() => {
    if (filteredCourseNodes && filteredCourseNodes.length) {
      const allNodes = getAllNodes(filteredCourseNodes).map((ele: any) =>
        String(ele.key)
      );
      let val = false;
      if (lecturePrecheckedNodes && lecturePrecheckedNodes.length) {
        const lecturePrecheckedNode = lecturePrecheckedNodes.map(String);
        const isAnyExits = lecturePrecheckedNode.some((ele: any) =>
          allNodes.includes(ele)
        );
        if (!isAnyExits) {
          if (selectedPlannedLecture.isComplete == 2) {
            val = false;
          } else {
            val = true;
          }
        }
        const isAnyPrevLecture = prevCheckedTopicCovered.some((ele: any) =>
          allNodes.includes(ele)
        );
        if (!isAnyPrevLecture) {
          val = false;
        }
        return val;
      }
    }
    return false;
  }, [
    filteredCourseNodes,
    lecturePrecheckedNodes,
    selectedPlannedLecture,
    prevCheckedTopicCovered,
  ]);
  console.log("allCourseNodes===", allCourseNodes, isPlannedMode, courseNodePL);
  return (
    <ScheduledDiv2Card screen={screen} mode={mode}>
      {["mybatchSyllabus", "lectureDetailTab", "mybatchTestSyllabus"].includes(
        mode
      ) && <>{header}</>}
      {!isPlannedMode &&
        ["myScheduleHome"].includes(mode) &&
        !isRevisionChapterSelected && (
          <div
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "selectAllCheckBoxStyleMB"
                : "selectAllCheckBoxStyle"
            }
          >
            <div
              style={{
                width: ["xs", "sm", "md"].includes(screen) ? "100%" : "350px",
              }}
            >
              <Input
                name="search"
                placeholder="Search"
                className="w-100"
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                allowClear
              ></Input>
            </div>
            <div className="d-flex align-items-center gap-4 w-100 justify-content-end">
              <div className="pr-2 d-flex align-items-center gap-2">
                <span
                  style={{
                    fontSize: ["xs", "sm", "md"].includes(screen)
                      ? "13px"
                      : "14px",
                  }}
                >
                  PL Mode
                </span>
                <Switch
                  checked={isPLModeEnabled}
                  onChange={(val: boolean) => setIsPLModeEnabled(val)}
                ></Switch>
              </div>
              <Checkbox
                disabled={isDisable}
                checked={checkeds}
                onChange={(e) => onChange(e, isPLModeEnabled)}
              >
                {label}
              </Checkbox>
            </div>
          </div>
        )}
      {allCourseNodes != null ? (
        <TreeDiv screen={screen}>
          <Spin spinning={isSearching}>
            <MultinodePicker
              fullTree={true}
              isMarkedAsRevision={isMarkedAsRevision}
              isRevisionChapterSelected={isRevisionChapterSelected}
              expandKeys={expandTopic}
              checkedKeysList={checkedTopicCovered}
              allCoveredTopics={allCoveredTopics}
              lecturePrecheckedNodes={lecturePrecheckedNodes}
              handleRemoveUnCheckKey={(data: any) => {
                handleRemoveUnCheckKeyCard(data);
              }}
              handleCheckedNodes={(data: any) => {
                handleCheckedNodesCard(data);
              }}
              handleOnlyCheckedNodes={(data: any) => {
                handleOnlyCheckedNodesCard(data);
              }}
              handleOnlyAllCheckedNodes={(data: any) => {
                handleOnlyAllCheckedNodesCard(data);
              }}
              nodes={filteredCourseNodes}
              disableCheckbox={true}
              mode={mode}
              chapterNodeDetail={chapterNodeDetail}
              courseNodePL={courseNodePL}
              isPlannedMode={isPlannedMode}
            ></MultinodePicker>
          </Spin>
        </TreeDiv>
      ) : (
        <NoResultFoundSearch
          primaryMessage="No data present"
          secondaryMessage={"No data available"}
        >
          <NoDataFoundIcon />
        </NoResultFoundSearch>
      )}
    </ScheduledDiv2Card>
  );
};
export default PlannedLectureViewCard;
